import { type IServicesList, type IPlan } from './serviceList'
import { type ISubscription } from '../redux/api/types'
import { STRIPE_STATUS } from './constants/stripe'

export const filterByProductId = (arr1: IServicesList[], arr2: ISubscription[]): IServicesList[] => {
  return arr1?.filter((obj1: IServicesList) => arr2?.some((obj2: ISubscription) => obj1?.plans?.some((plan: IPlan) => plan?.productId === obj2?.product) &&
    ((obj2.status === STRIPE_STATUS.ACTIVE) || (obj2.status === STRIPE_STATUS.ON_GRACE_PERIOD) || (obj2.status === STRIPE_STATUS.PAST_DUE))))
}
